/**
 * Clickout product market (`epm`) — resolved once at `ecom.init`, without the
 * host passing anything.
 *
 * Order: post `amazon_market` → website `ecom_amazon_market`. A Walmart post
 * (`content_type` `ecommerce_impact_walmart`) is always `walmart`, matching
 * yoto-web's `isEcomWalmart()` branch.
 */

import type { SdkContext } from '../types';

const WALMART_CONTENT_TYPE = 'ecommerce_impact_walmart';

function readString(source: unknown, key: string): string {
  if (!source || typeof source !== 'object') return '';
  const value = (source as Record<string, unknown>)[key];
  return typeof value === 'string' ? value.trim() : '';
}

/** `epm` for this page, or `''` when neither the post nor the website names one. */
export function resolveEcomProductMarket(ctx: SdkContext, post: unknown): string {
  const data = post && typeof post === 'object' ? (post as Record<string, unknown>).data : null;

  if (readString(data, 'content_type') === WALMART_CONTENT_TYPE) return 'walmart';

  return (
    readString(data, 'amazon_market') ||
    readString(post, 'amazon_market') ||
    ctx.getConfig().ecom.amazonMarket?.trim() ||
    ''
  );
}
